import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = {
    browse: [
      { label: '韩漫推荐', path: '/category/korean' },
      { label: '日漫推荐', path: '/category/japanese' },
      { label: '国漫推荐', path: '/category/chinese' },
      { label: '排行榜', path: '/' },
    ],
    about: [
      { label: '关于我们', path: '/about' },
      { label: '品牌介绍', path: '/about' },
      { label: '联系我们', path: '/about' },
    ],
    help: [
      { label: '常见问题', path: '/about' },
      { label: '阅读指南', path: '/about' },
    ],
  };

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="px-4 md:px-6 py-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-heart-fill text-primary-500 text-xl"></i>
                </div>
                <span className="font-heading text-xl font-semibold text-background-50">女神漫画</span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                女神漫画 — 韩漫日漫国漫全集免费推荐平台，提供排行榜热门精选与下拉式在线阅读体验。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">浏览漫画</h4>
              <ul className="space-y-2.5">
                {footerLinks.browse.map((link) => (
                  <li key={link.label}>
                    <Link to={link.path} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">关于</h4>
              <ul className="space-y-2.5">
                {footerLinks.about.map((link) => (
                  <li key={link.label}>
                    <Link to={link.path} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">帮助</h4>
              <ul className="space-y-2.5">
                {footerLinks.help.map((link) => (
                  <li key={link.label}>
                    <Link to={link.path} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
              <div className="mt-4 pt-4 border-t border-background-700">
                <p className="text-xs text-background-500">联系邮箱</p>
                <a href="mailto:contact@goddessmanga.com" className="text-sm text-primary-400 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap">
                  contact@goddessmanga.com
                </a>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-700 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; 2026 女神漫画 GoddessManga. 本站所有漫画均来自网络，仅供学习交流使用。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">隐私政策</a>
              <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">服务条款</a>
              <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}